import { z } from 'zod';
import { AggregationTypeSchema, CostCategorySchema, createPaginatedResponseSchema, EntityStatusSchema, IdParamsSchema, MetadataSchema, PaginationQuerySchema, } from '../common/index.js';
export const FeatureSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    external_id: z.string(),
    feature_name: z.string().min(1).max(100),
    description: z.string().optional(),
    status: EntityStatusSchema,
    metadata: MetadataSchema,
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const FeatureValueSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    feature_id: z.string(),
    revenue_per_unit: z.number().optional(),
    default_price_cents: z.number().int().optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const FeatureBillableSignalSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    feature_id: z.string(),
    billable_signal_id: z.string(),
    is_primary: z.boolean().default(true),
    created_at: z.string().datetime(),
});
export const FeatureCostSignalSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    environment_id: z.string(),
    feature_id: z.string(),
    cost_signal_id: z.string(),
    created_at: z.string().datetime(),
});
export const CreateFeatureSchema = z.object({
    external_id: z.string().min(1).max(100),
    feature_name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    status: EntityStatusSchema.default('draft'),
    metadata: MetadataSchema.optional(),
    billable_signal: z
        .object({
        signal_name: z.string().min(1).max(100),
        signal_code: z.string().min(1).max(100),
        aggregation_type: AggregationTypeSchema,
        unit_label: z.string().max(50).default('units'),
        description: z.string().max(500).optional(),
    })
        .optional(),
    cost_signal_ids: z.array(z.string()).optional(),
    value: z
        .object({
        revenue_per_unit: z.number().optional(),
        default_price_cents: z.number().int().optional(),
    })
        .optional(),
});
export const UpdateFeatureSchema = z.object({
    external_id: z.string().min(1).max(100).optional(),
    feature_name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).optional().nullable(),
    status: EntityStatusSchema.optional(),
    metadata: MetadataSchema.optional(),
    billable_signal: z
        .object({
        signal_id: z.string().optional(),
        signal_name: z.string().min(1).max(100),
        signal_code: z.string().min(1).max(100),
        aggregation_type: AggregationTypeSchema,
        unit_label: z.string().max(50),
    })
        .optional(),
    cost_signal_ids: z.array(z.string()).optional(),
    value: z
        .object({
        revenue_per_unit: z.number().optional().nullable(),
        default_price_cents: z.number().int().optional().nullable(),
    })
        .optional(),
});
export const FeatureResponseSchema = FeatureSchema.extend({
    billable_signal: z
        .object({
        signal_id: z.string(),
        signal_name: z.string(),
        signal_code: z.string(),
        aggregation_type: AggregationTypeSchema,
        unit_label: z.string(),
    })
        .optional(),
    cost_signals: z
        .array(z.object({
        signal_id: z.string(),
        signal_name: z.string(),
        signal_code: z.string(),
        unit_label: z.string(),
        description: z.string().nullable().optional(),
        cost_config: z
            .object({
            fixed_cost_cents: z.number().int().nullable().optional(),
            cost_category: CostCategorySchema.nullable().optional(),
        })
            .optional(),
    }))
        .optional(),
    value: z
        .object({
        revenue_per_unit: z.number().nullable().optional(),
        default_price_cents: z.number().int().nullable().optional(),
    })
        .optional(),
});
export const FeatureQuerySchema = PaginationQuerySchema.extend({
    status: EntityStatusSchema.optional(),
    search: z.string().optional(),
    external_id: z.string().optional(),
});
export const PaginatedFeaturesResponseSchema = createPaginatedResponseSchema(FeatureResponseSchema);
export const FeatureParamsSchema = IdParamsSchema;
export const DeleteFeatureResponseSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=index.js.map